import './searchFilter.css';

export default function SearchFilter({ filterName, filterList, selectedValue, changeHandler }) {
    return (
        <ul className="search-filter-list">
            <li>
                <label htmlFor={`${filterName}-any`}>
                    <input id={`${filterName}-any`} type="radio" name={filterName} value="" checked={"" === selectedValue} onChange={changeHandler} />
                    Any
                </label>
            </li>
            {filterList.map(i => {
                return (
                    <li key={i.id}>
                        <label htmlFor={`${filterName}-${i.id}`}>
                            <input id={`${filterName}-${i.id}`} type="radio" name={filterName} value={i.id} checked={i.id === selectedValue} onChange={changeHandler} />
                            {i.name}
                        </label>
                    </li>
                );
            })}
        </ul>
    );
}